import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-performance',
  templateUrl: './performance.component.html',
  styleUrls: ['./performance.component.css'],
})
export class PerformanceComponent implements OnInit {
  url: string = 'seoPerformance';

  loading: boolean = true;
  saving: boolean = false;

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
    
  ];

  // ── Filter state ──────────────────────────────────────────────────────────
  selectedCity: string = 'miami';
  selectedUniverse: string = 'courier';
  selectedCategory: string = 'all';
  selectedDateRange: string = '30days';
  selectedChannel: string = 'google_seo';
  selectedCampaign: string = 'all';
  selectedUrl: string = 'all';

  pendingCity: string = 'miami';
  pendingUniverse: string = 'courier';
  pendingCategory: string = 'all';
  pendingDateRange: string = '30days';
  pendingChannel: string = 'google_seo';
  pendingCampaign: string = 'all';
  pendingUrl: string = 'all';

  // ── Filter Dropdowns options ──────────────────────────────────────────────
  cities = [
    { value: 'all', label: 'View All' },
    { value: 'miami', label: 'Miami' },
    { value: 'fort_lauderdale', label: 'Fort Lauderdale' },
  ];

  universes = [
    { value: 'all', label: 'View All' },
    { value: 'courier', label: 'Courier' },
  ];

  categories = [
    { value: 'all', label: 'View All' },
    { value: 'same_day', label: 'Same-Day Courier' },
  ];

  dateRanges = [
    { value: '30days', label: 'Last 30 Days' },
    { value: '7days', label: 'Last 7 Days' },
  ];

  channels = [
    { value: 'google_seo', label: 'Google SEO' },
    { value: 'bing_seo', label: 'Bing SEO' },
  ];

  campaigns = [{ value: 'all', label: 'View All' }];

  urls = [{ value: 'all', label: 'View All' }];

  // ── Stat Cards ────────────────────────────────────────────────────────────
  stats = {
    trackedKeywords: {
      value: 184,
      trend: '12 vs last 30 days',
      icon: 'fas fa-crosshairs',
      bg: 'bg-blue',
      arrow: 'up',
      trendColor: 'text-success',
    },
    keywordsUp: {
      value: 42,
      trend: '18 vs last 30 days',
      icon: 'fas fa-arrow-up',
      bg: 'bg-green',
      arrow: 'up',
      trendColor: 'text-success',
    },
    keywordsDown: {
      value: 17,
      trend: '6 vs last 30 days',
      icon: 'fas fa-arrow-down',
      bg: 'bg-red',
      arrow: 'down',
      trendColor: 'text-danger',
    },
    avgPosition: {
      value: 18.6,
      trend: '1.7 vs last 30 days',
      icon: 'fas fa-chart-line',
      bg: 'bg-green',
      arrow: 'up',
      trendColor: 'text-success',
    },
    organicClicks: {
      value: '1,240',
      trend: '11% vs last 30 days',
      icon: 'fas fa-mouse-pointer',
      bg: 'bg-blue',
      arrow: 'up',
      trendColor: 'text-success',
    },
    quoteRequests: {
      value: 36,
      trend: '8 vs last 30 days',
      icon: 'far fa-comment-dots',
      bg: 'bg-green',
      arrow: 'up',
      trendColor: 'text-success',
    },
    bookings: {
      value: 14,
      trend: '3 vs last 30 days',
      icon: 'far fa-calendar-check',
      bg: 'bg-green',
      arrow: 'up',
      trendColor: 'text-success',
    },
    revenueEstimate: {
      value: '$4,850',
      trend: '$650 vs last 30 days',
      icon: 'fas fa-dollar-sign',
      bg: 'bg-green',
      arrow: 'up',
      trendColor: 'text-success',
    },
  };

  // ── Datasets ──────────────────────────────────────────────────────────────
  healthSummary = [
    {
      status: 'up',
      text: 'Miami Courier is improving in keyword visibility, but conversion performance is uneven.',
      icon: 'fas fa-arrow-circle-up text-success',
    },
    {
      status: 'up',
      text: 'Legal Services and Same-Day Courier show the strongest ranking movement.',
      icon: 'fas fa-arrow-circle-up text-success',
    },
    {
      status: 'warn',
      text: 'Courier Services has high impressions but weak CTR.',
      icon: 'fas fa-exclamation-circle text-warning',
    },
    {
      status: 'down',
      text: 'Long Distance Courier has low keyword coverage and needs content support.',
      icon: 'fas fa-arrow-circle-down text-danger',
    },
    {
      status: 'stable',
      text: 'Fort Lauderdale is stable with positive trend.',
      icon: 'fas fa-plus-circle text-success',
    },
    {
      status: 'info',
      text: 'Overall SEO trend in Miami is positive.',
      icon: 'fas fa-info-circle text-primary',
    },
  ];

  topGaining = [
    {
      keyword: 'same day courier miami',
      url: '/same-day-courier/',
      prev: 18,
      curr: 9,
      change: 9,
    },
    {
      keyword: 'legal courier miami',
      url: '/legal-services/',
      prev: 22,
      curr: 13,
      change: 9,
    },
    {
      keyword: 'rush courier miami',
      url: '/rush-courier/',
      prev: 16,
      curr: 11,
      change: 5,
    },
    {
      keyword: 'courier near miami',
      url: '/courier-services/',
      prev: 14,
      curr: 10,
      change: 4,
    },
    {
      keyword: 'express courier miami',
      url: '/express-courier/',
      prev: 25,
      curr: 17,
      change: 8,
    },
  ];

  topLosing = [
    {
      keyword: 'local courier miami',
      url: '/local-courier/',
      prev: 8,
      curr: 15,
      change: -7,
    },
    {
      keyword: 'delivery service miami',
      url: '/courier-services/',
      prev: 19,
      curr: 27,
      change: -8,
    },
    {
      keyword: 'business courier miami',
      url: '/business-courier/',
      prev: 11,
      curr: 16,
      change: -5,
    },
    {
      keyword: 'courier miami 24 hours',
      url: '/same-day-courier/',
      prev: 10,
      curr: 18,
      change: -8,
    },
    {
      keyword: 'cheap courier miami',
      url: '/courier-services/',
      prev: 23,
      curr: 31,
      change: -8,
    },
  ];

  urlPerformance = [
    {
      url: '/same-day-courier/',
      keywords: 31,
      pos: 12.7,
      clicks: 420,
      conv: 11,
      status: 'Strong',
      badge: 'bg-success-light text-success',
    },
    {
      url: '/legal-services/',
      keywords: 26,
      pos: 14.2,
      clicks: 310,
      conv: 9,
      status: 'Improving',
      badge: 'bg-info-light text-info',
    },
    {
      url: '/courier-services/',
      keywords: 48,
      pos: 18.9,
      clicks: 390,
      conv: 3,
      status: 'Low CTR',
      badge: 'bg-warning-light text-warning',
    },
    {
      url: '/long-distance-courier/',
      keywords: 15,
      pos: 28.4,
      clicks: 55,
      conv: 1,
      status: 'Needs Support',
      badge: 'bg-danger-light text-danger',
    },
    {
      url: '/rush-courier/',
      keywords: 22,
      pos: 15.8,
      clicks: 140,
      conv: 4,
      status: 'Stable',
      badge: 'bg-primary-light text-primary',
    },
  ];

  conversionPerformance = [
    {
      cat: 'Same-Day Courier',
      clicks: 420,
      quotes: 14,
      bookings: 6,
      rate: 4.7,
    },
    { cat: 'Legal Services', clicks: 310, quotes: 11, bookings: 5, rate: 5.1 },
    { cat: 'Courier Services', clicks: 390, quotes: 6, bookings: 2, rate: 2.0 },
    { cat: 'Long Distance', clicks: 55, quotes: 2, bookings: 1, rate: 5.4 },
    { cat: 'Rush Courier', clicks: 140, quotes: 3, bookings: 0, rate: 0.0 },
  ];

  cityPerformance = [
    {
      city: 'Miami',
      keywords: 184,
      pos: 18.6,
      clicks: '1,240',
      bookings: 14,
      trend: 'up',
    },
    {
      city: 'Fort Lauderdale',
      keywords: 92,
      pos: 24.1,
      clicks: 410,
      bookings: 4,
      trend: 'right',
    },
    {
      city: 'Boca Raton',
      keywords: 61,
      pos: 31.5,
      clicks: 180,
      bookings: 1,
      trend: 'down',
    },
    {
      city: 'Orlando',
      keywords: 48,
      pos: 34.2,
      clicks: 95,
      bookings: 0,
      trend: 'right',
    },
    {
      city: 'Tampa',
      keywords: 37,
      pos: 33.8,
      clicks: 70,
      bookings: 0,
      trend: 'right',
    },
  ];

  competitiveMovement = [
    {
      comp: 'Company A',
      shared: 42,
      gained: 18,
      weGained: 9,
      risk: 'High',
      badge: 'bg-danger-light text-danger',
    },
    {
      comp: 'Company B',
      shared: 31,
      gained: 7,
      weGained: 12,
      risk: 'Medium',
      badge: 'bg-warning-light text-warning',
    },
    {
      comp: 'Company C',
      shared: 22,
      gained: 4,
      weGained: 8,
      risk: 'Low',
      badge: 'bg-success-light text-success',
    },
  ];

  performanceFindings = [
    {
      type: 'danger',
      icon: 'fas fa-arrow-down',
      text: 'High Traffic / Weak Conversion - Courier Services',
      badge: 'High',
      badgeClass: 'bg-danger-light text-danger',
    },
    {
      type: 'danger',
      icon: 'fas fa-exclamation-circle',
      text: 'Mapping Divergence - Supporting URL outranks Primary',
      badge: 'High',
      badgeClass: 'bg-danger-light text-danger',
    },
    {
      type: 'warning',
      icon: 'fas fa-exclamation-triangle',
      text: 'CTR Weakness - High impressions, low CTR',
      badge: 'Medium',
      badgeClass: 'bg-warning-light text-warning',
    },
    {
      type: 'danger',
      icon: 'fas fa-arrow-down',
      text: 'Local Pack Decline - West Palm Beach',
      badge: 'High',
      badgeClass: 'bg-danger-light text-danger',
    },
    {
      type: 'warning',
      icon: 'fas fa-minus-circle',
      text: 'Stagnant Page - Long Distance Courier',
      badge: 'Medium',
      badgeClass: 'bg-warning-light text-warning',
    },
    {
      type: 'success',
      icon: 'fas fa-arrow-up',
      text: 'Positive Trend - Same-Day Courier conversions improving',
      badge: 'Low',
      badgeClass: 'bg-success-light text-success',
    },
  ];

  specialistReviews = [
    {
      finding: 'Conversion Review - Courier Services',
      module: 'ON-PAGE',
      moduleClass: 'text-primary',
      priority: 'High',
      reason: 'Traffic up, conversion down',
    },
    {
      finding: 'Mapping Review - Miami Legal Intent',
      module: 'URL Mapping',
      moduleClass: 'text-primary',
      priority: 'High',
      reason: 'Supporting URL outranks Primary',
    },
    {
      finding: 'Internal Support Review - /legal-services/',
      module: 'Internal Links',
      moduleClass: 'text-primary',
      priority: 'Medium',
      reason: 'Authority landing page stagnating',
    },
    {
      finding: 'Technical Recheck - /same-day-courier/',
      module: 'Technical QA',
      moduleClass: 'text-primary',
      priority: 'High',
      reason: 'Post-fix visibility not recovering',
    },
    {
      finding: 'Local Visibility Review - WPB',
      module: 'Local SEO',
      moduleClass: 'text-primary',
      priority: 'High',
      reason: 'Local Pack down 12%',
    },
    {
      finding: 'Authority Impact Review - Legal Cluster',
      module: 'Off-Page',
      moduleClass: 'text-primary',
      priority: 'Medium',
      reason: 'Backlinks up, rankings flat',
    },
  ];

  activeMonitoring = [
    {
      module: 'ON-PAGE',
      change: 'Title & Meta Updated',
      target: '/legal-services/',
      expected: 'Improve CTR and visibility',
      start: 'May 18, 2025',
      window: '30 Days',
      status: 'Monitoring',
      progress: 20,
    },
    {
      module: 'INTERNAL LINKS',
      change: '5 Internal Links Added',
      target: '/legal-services/',
      expected: 'Increase authority flow and rankings',
      start: 'May 17, 2025',
      window: '45 Days',
      status: 'Monitoring',
      progress: 35,
    },
    {
      module: 'TECHNICAL QA',
      change: 'Canonical Fixed',
      target: '/same-day-courier/',
      expected: 'Restore indexation and rankings',
      start: 'May 15, 2025',
      window: '30 Days',
      status: 'Monitoring',
      progress: 50,
    },
    {
      module: 'LOCAL SEO',
      change: 'GBP Updated - Miami',
      target: 'Miami (Local Pack)',
      expected: 'Improve local visibility and engagement',
      start: 'May 12, 2025',
      window: '30 Days',
      status: 'Monitoring',
      progress: 60,
    },
    {
      module: 'OFF-PAGE',
      change: 'Backlink Acquired',
      target: '/same-day-courier/',
      expected: 'Improve authority and rankings',
      start: 'May 10, 2025',
      window: '45 Days',
      status: 'Monitoring',
      progress: 75,
    },
  ];

  recentActivity = [
    {
      activity: 'Monitoring Request Created',
      details: 'Title updated for /legal-services/',
      by: 'AI',
      date: 'May 18, 2025',
    },
    {
      activity: 'Finding Detected',
      details: 'High Traffic / Weak Conversion',
      by: 'AI',
      date: 'May 18, 2025',
    },
    {
      activity: 'Signal Sent',
      details: 'Conversion Review → ON-PAGE',
      by: 'AI',
      date: 'May 18, 2025',
    },
    {
      activity: 'Monitoring Extended',
      details: 'Internal Links impact observation',
      by: 'AI',
      date: 'May 17, 2025',
    },
    {
      activity: 'Finding Closed',
      details: 'Technical Fix impact - Positive',
      by: 'AI',
      date: 'May 16, 2025',
    },
    {
      activity: 'Baseline Recorded',
      details: 'GBP update baseline captured',
      by: 'AI',
      date: 'May 12, 2025',
    },
  ];

  constructor(
    private router: Router,
    private dataService: DataService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.loading = false;
  }

  onFilterChange(): void {
    this.selectedCity = this.pendingCity;
    this.selectedUniverse = this.pendingUniverse;
    this.selectedCategory = this.pendingCategory;
    this.selectedDateRange = this.pendingDateRange;
    this.selectedChannel = this.pendingChannel;
    this.selectedCampaign = this.pendingCampaign;
    this.selectedUrl = this.pendingUrl;
    // apply filter logic
  }
}
